/* istanbul ignore file */

import { Component, computed, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { CardMode } from '@components/card/card.component';
import {
    CaregiverFlightFormGroup,
    FlightRequestDetailsFormGroup,
} from '@components/request/travel-request-card/form-groups/detail-form-groups/travel/flight-request.formgroup';
import { MdsCheckboxComponent, MdsExpansionPanelComponent } from '@medpacesoftwaredevelopment/designsystem';
import { Caregiver, getCaregiverFullName } from '@models/patient';
import { FlightDetailsComponent } from './flight-details/flight-details.component';

@Component({
    selector: 'medpace-flight-request-details',
    templateUrl: './flight-request-details.component.html',
    styleUrls: ['./flight-request-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FlightDetailsComponent, MdsExpansionPanelComponent, MdsCheckboxComponent],
})
export class FlightRequestDetailsComponent {
    public readonly mode: InputSignal<CardMode> = input.required();
    public readonly formGroup: InputSignal<FlightRequestDetailsFormGroup> = input.required();

    public accompanyingCaregivers = computed(() => {
        return this.formGroup().controls.caregivers.controls.filter(
            (control) =>
                !!control.controls.details.value.flightDetails?.id ||
                control.controls.details.value?.bookIdenticalTrip === true
        );
    });

    public hasAnyNonDisabledCaregiverControls(caregivers: CaregiverFlightFormGroup[]): boolean {
        return caregivers.filter((caregiverControl) => !caregiverControl.disabled).length !== 0;
    }

    public getCaregiverFullName(caregiver: Caregiver | undefined): string {
        return caregiver ? getCaregiverFullName(caregiver) : '';
    }
}
